import ReservationIndex from '@/Libs/Pages/Panel/Reservation/ReservationIndex.vue'
import ReservationDetail from '@/Libs/Pages/Panel/Reservation/ReservationDetail.vue'
import ReservationForm from '@/Libs/Pages/Panel/Reservation/ReservationForm.vue'

export default [
    {
        name: 'reservation',
        path: '/reservation',
        component: ReservationIndex,
        meta: {
            title: 'reservation.title.list',
            permission: 'reservation_list'
        },
    },
    {
        name: 'reservation-create',
        path: '/reservation/create',
        component: ReservationForm,
        meta: {
            title: 'reservation.title.create',
            permission: 'reservation_create'
        },
    },
    {
        name: 'reservation-detail',
        path: '/reservation/detail/:id',
        component: ReservationDetail,
        meta: {
            title: 'reservation.title.detail',
            permission: 'reservation_show'
        },
    },
    {
        name: 'reservation-update',
        path: '/reservation/update/:id',
        component: ReservationForm,
        meta: {
            title: 'reservation.title.edit',
            permission: 'reservation_create'
        },
    }
];